// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ReadyToGoRingFiltersFragmentDoc } from '../../../graphql/api/product/rings/ready-to-go/fragments/readyToGoRingFilters.fragment.generated';
import { ProductGridFragmentDoc } from '../../../components/rings/product-grid/ProductGrid.generated';
import { ProductPageListingFragmentDoc } from '../../../graphql/api/cms/pageProductListing.fragment.generated';
import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const ReadyToGoRingBrowseDocument = gql`
    query readyToGoRingBrowse($currency: CurrencyInput!, $region: RegionCode!, $filter: CatalogueReadyToGoRingsFilterInput!, $page: Int!, $limit: Int!, $locale: Locale!, $sortBy: CatalogueSortOrder!) {
  catalogueReadyToGoRingsFilters(input: $filter) {
    ...readyToGoRingFilters
  }
  catalogueReadyToGoRingsAggregate(filter: $filter) {
    count
  }
  catalogueReadyToGoRings(
    filter: $filter
    sort: {by: $sortBy, currency: $currency}
    pagination: {page: $page, limit: $limit}
  ) {
    ...productGrid
  }
}
    ${ReadyToGoRingFiltersFragmentDoc}
${ProductGridFragmentDoc}`;

export function useReadyToGoRingBrowseQuery(options?: Omit<Urql.UseQueryArgs<never, SchemaTypes.ReadyToGoRingBrowseQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<SchemaTypes.ReadyToGoRingBrowseQuery, SchemaTypes.ReadyToGoRingBrowseQueryVariables | undefined>({ query: ReadyToGoRingBrowseDocument, variables: undefined, ...options });
};
export const ReadyToGoRingsContentDocument = gql`
    query readyToGoRingsContent($locale: Locale!, $path: String!, $currency: CurrencyInput!, $region: RegionCode!) {
  pageProductListing(path: $path, locale: $locale) {
    ...productPageListing
  }
}
    ${ProductPageListingFragmentDoc}`;

export function useReadyToGoRingsContentQuery(options?: Omit<Urql.UseQueryArgs<never, SchemaTypes.ReadyToGoRingsContentQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<SchemaTypes.ReadyToGoRingsContentQuery, SchemaTypes.ReadyToGoRingsContentQueryVariables | undefined>({ query: ReadyToGoRingsContentDocument, variables: undefined, ...options });
};